import { Injectable } from '@angular/core';
import { SirenResponse, SirenAction, SirenLink } from '../model';

@Injectable()
export class SirenCache {

  private _cache = new Map<string, any>();
  private _actions = new Map<string, SirenAction>();
  private _links = new Map<string, SirenLink>();
  protected _isRestoring = false;

  getResponse(key: string): SirenResponse {
    return this._cache.get(key);
  }

  setResponse(key: string, value: SirenResponse): void {
    try {
      this._cache.set(key, value);

      if (value.actions != null && value.actions.length > 0) {
        value.actions.forEach(item => {
          this._actions.set(item.name, item);
        })
      }

      if (value.links != null && value.links.length > 0) {
        value.links.forEach(item => {
          this._links.set(item.rel[0], item);
        });
      }

    } catch (err) {
      console.error('Error saving response', err);
    }
  }

  restore(responses: { [key: string]: SirenResponse }): void {
    try {
      this._isRestoring = true;
      for (const key of Object.keys(responses)) {
        this.setResponse(key, responses[key]);
      }
    } finally {
      this._isRestoring = false;
    }
  }

  getAction(name: string): SirenAction {
    return this._actions.get(name);
  }

  getLink(name: string): SirenLink {
    return this._links.get(name);
  }
}
